{
	"es": {
	},
	"fr": {
	},
	"de": {
	}
}